import React from "react";

import "../styles/about.css"

export const About = () => {
    return (
        <>
        <div className='container' id="AboutHeader">
            <div className='header flex text-center'>
            <h5 data-aos="fade-down" data-aos-anchor="#AboutHeader">Educare.ignuxas.com</h5>
            <h2 data-aos="fade-down" data-aos-anchor="#AboutHeader" data-aos-delay="100"> Who are we?</h2>
            </div> 
        </div>
        <div id="About">
            <div data-aos="flip-right" data-aos-anchor="#About">
                <h2>What we do</h2>
                <p>
                    Are you a young adult feeling unsure about your next step? Educare is here to help! Our AI-powered platform provides personalized insights to guide you towards the perfect educational path and a fulfilling career that aligns with your unique goals and aspirations.
                </p>
            </div>
            <div data-aos="flip-left" data-aos-anchor="#About">
                <h2>Our mission</h2>
                <p>
                    Whether you’re looking for the right university, career path, or simply need some advice, we’ve got you covered. Our platform is designed to help you make informed decisions about your future and achieve your full potential.
                </p>
            </div>
        </div>
        </>
    );
}
